var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsBank = function SvgUsBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "us-bank_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".us-bank_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "us-bank_svg__st0",
    d: "M0 0h40v26H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "us-bank_svg__Calque_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "us-bank_svg___x31__2_",
    d: "M9.6 10.855v4.16l3.51 1.235 3.51-1.235v-4.16H9.6z",
    style: {
      fill: "#dc142e"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "us-bank_svg___x31__1_",
    className: "us-bank_svg__st0",
    d: "M13.11 14.885h-1.105v-.325c-.13.26-.455.39-.91.39-.52 0-.975-.26-.975-.975V11.96h1.105v1.56c0 .325.065.585.325.585.195 0 .455-.13.455-.585v-1.56h1.105v2.925zm2.08-2.08c0-.13-.065-.195-.13-.26a.493.493 0 0 0-.26-.13c-.195 0-.325.065-.325.26 0 .065.065.13.13.195.195.065.585.13.975.26.325.13.715.325.715.78 0 .78-.78 1.04-1.495 1.04-.715 0-1.43-.26-1.43-1.04h1.17c0 .13.065.195.13.26s.195.065.26.065.325-.065.325-.26-.13-.26-.65-.26c-.845-.13-1.235-.39-1.235-.91 0-.78.78-.91 1.365-.91.65 0 1.365.195 1.43.91h-.975z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "us-bank_svg___x31_",
    d: "M17.075 10.855h1.105v1.43a.927.927 0 0 1 .78-.39c.975 0 1.3.78 1.3 1.495 0 .78-.39 1.56-1.235 1.56-.52 0-.715-.26-.845-.39v.26h-1.105v-3.965zm1.56 1.885c-.39 0-.455.325-.455.715 0 .325.065.78.455.78s.455-.325.455-.78c.065-.39-.065-.715-.455-.715zm4.745 1.495c0 .26 0 .455.13.65h-1.17c0-.065-.065-.195-.065-.26-.26.26-.585.325-.91.325-.585 0-1.04-.26-1.04-.845 0-.91 1.105-.845 1.69-.975.195 0 .26-.065.26-.26s-.195-.26-.325-.26c-.325 0-.39.195-.39.26h-1.04c.065-.78.78-.975 1.495-.975 1.365 0 1.365.585 1.365 1.17v1.17zm-1.105-.65c-.13.065-.26.13-.455.13-.26.065-.325.13-.325.26s.13.26.325.26c.26 0 .455-.195.455-.455v-.195zm1.495-1.625h1.105v.325c.26-.26.52-.455.91-.455.52 0 .975.26.975.975v2.015h-1.105v-1.56c0-.325-.065-.585-.325-.585-.195 0-.455.13-.455.585v1.56H23.77v-2.86zm3.38-1.105h1.105v1.95l.715-.845h1.3l-1.04 1.105 1.235 1.82h-1.3l-.585-1.04-.195.26v.845H27.15v-4.095z",
    style: {
      fill: "#253779"
    }
  })));
};
export default SvgUsBank;